/* globals window */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { kebabCase, includes } from 'lodash';
import { killEvent } from 'event-helpers';
import { camelize } from 'inflected';
import displayName from 'component-lib/displayName';

import { NORMAL, ACTIVE, DISABLED } from './selectsStatuses';

import selectsStyles from './Selects-v2.scss';

export default function SelectMultiSelectGenerator(type, customStyles) {
    return class SelectMultiSelect extends Component {
        static displayName = displayName(`Forms/Selects-v2/${camelize(type)}MultiSelect`);

        static propTypes = {
            id: PropTypes.string.isRequired,
            onSelect: PropTypes.func.isRequired,
            selectedIds: PropTypes.array.isRequired,
            data: PropTypes.arrayOf(PropTypes.shape({
                id: PropTypes.string.isRequired,
                value: PropTypes.node.isRequired,
            }).isRequired,).isRequired,
            placeholder: PropTypes.string,
            withSmallCheckboxes: PropTypes.bool,
            disabled: PropTypes.bool,
        };

        static defaultProps = {
            withSmallCheckboxes: false,
            placeholder: '',
            disabled: false,
        };

        constructor(props) {
            super(props);

            this.state = { status: NORMAL };
        }

        componentWillUnmount() {
            this.closeDropdownMenu();
        }

        onSelectItem(...args) {
            this.onItemClick = true;

            this.props.onSelect(...args);
        }

        get items() {
            return this.props.data;
        }

        get selectedValues() {
            const { data } = this.props;

            const selectedItems = data.filter(({ id }) => this.isSelectedItem(id)) || [];

            return selectedItems.map(({ value }) => value);
        }

        toggleDropdown = (e) => {
            if (this.state.status === NORMAL) {
                this.openDropdownMenu();
            } else {
                this.closeDropdownMenu(e);
            }
        };

        openDropdownMenu = () => {
            this.setState({ status: ACTIVE });
            setTimeout(() => window.addEventListener('click', this.closeDropdownMenu), 0);
        };

        closeDropdownMenu = (e) => {
            if (!this.onItemClick) {
                window.removeEventListener('click', this.closeDropdownMenu);
                this.setState({ status: NORMAL });
            } else {
                killEvent(e);
            }

            this.onItemClick = false;
        };

        isSelectedItem(id) {
            const { selectedIds } = this.props;

            return includes(selectedIds, id);
        }

        render() {
            const {
                id: selectId,
                placeholder,
                disabled = false,
                withSmallCheckboxes,
            } = this.props;
            const { status: stateStatus } = this.state;
            const status = disabled ? DISABLED : stateStatus;
            const selectedValues = this.selectedValues;
            let text = placeholder;
            let textClass = 'select-text';
            if (selectedValues.length) {
                textClass = `${textClass}-selected`;
                text = selectedValues.join(', ');
            }
            const checkboxType = withSmallCheckboxes ? 'small' : 'large';

            const styles = customStyles || selectsStyles;

            return (
                <div
                    role="menu"
                    tabIndex="-1"
                    data-form-type="select-multi-select"
                    data-action={`select-${kebabCase(selectId)}`}
                    onClick={this.toggleDropdown}
                    data-select={kebabCase(selectId)}
                    className={styles[`select-container-${type}`]}
                >
                    <div className={styles[`select-${status}`]}>
                        <span className={styles[textClass]}>
                            {text}
                        </span>
                        <span className={styles[`select-arrow-${status}`]} />
                    </div>
                    {
                        status === ACTIVE &&
                        <div className={styles['select-list-scrollable']}>
                            {
                                this.items.map(({ id, value }) => (
                                    <span
                                        role="menuitem"
                                        tabIndex="-1"
                                        className={styles['select-item']}
                                        key={id}
                                        data-select-item={id}
                                        data-selected={this.isSelectedItem(id)}
                                        data-action={`select-${kebabCase(id)}`}
                                        onClick={() => { this.onSelectItem(id, selectId); }}
                                    >
                                        <span className={styles['checkbox-inline']}>
                                            <span className={styles[`checkbox-${checkboxType}`]}>
                                                <input
                                                    className={styles['checkbox-hidden']}
                                                    type="checkbox"
                                                    onChange={() => {}}
                                                    checked={this.isSelectedItem(id)}
                                                />
                                                <label htmlFor={id} className={styles['checkbox-label']}>
                                                    <span className={styles['checkbox-box']} />
                                                    <span id={id} className={styles['checkbox-text']}>
                                                        {value}
                                                    </span>
                                                </label>
                                            </span>
                                        </span>
                                    </span>
                                ))
                            }
                        </div>
                    }
                </div>
            );
        }
    };
}
